(function () {
  document.querySelectorAll('.process-reveal').forEach((root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const viewport = root.querySelector('.process-reveal__viewport');
    const track    = root.querySelector('[data-track]');
    const cards    = Array.from(root.querySelectorAll('.pr-card'));
    const live     = root.querySelector('[data-live]');

    let innerTrackWidth = 0;
    let travelX = 0; 
    let lastFocus = -1;
    let rafId = null;

    const headerOffset   = parseFloat(root.dataset.headerOffset || 0);
    const baseScaleData  = parseFloat(root.dataset.baseScale || 0.7);
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mqlMobile      = window.matchMedia('(max-width: 989px)');

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    function layout() {

      const trackStyles = getComputedStyle(track);
      const cardWidth = parseFloat(trackStyles.getPropertyValue('grid-auto-columns')); 
      const gap       = parseFloat(trackStyles.getPropertyValue('column-gap')) || 0;

      innerTrackWidth = (cards.length * cardWidth) + ((cards.length - 1) * gap);

      track.style.width = `${innerTrackWidth}px`;

      travelX = Math.max(0, innerTrackWidth - cardWidth);

      root.style.height = `${window.innerHeight + travelX}px`;

      const sticky = root.querySelector('.process-reveal__sticky');
      if (sticky) sticky.style.top = `calc(${headerOffset}px)`;

      update(); 
    }

    function update() {
      const rect = root.getBoundingClientRect();

      const progress = clamp((headerOffset - rect.top) / (travelX || 1), 0, 1);

      track.style.transform = `translate3d(${-(progress * travelX)}px,0,0)`;

      const viewW = viewport.clientWidth;
      const viewRect = viewport.getBoundingClientRect();
      const viewCenter = viewRect.left + viewW / 2;

      const trackStyles = getComputedStyle(track);
      const cardWidth = parseFloat(trackStyles.getPropertyValue('grid-auto-columns'));
      const isMobile = mqlMobile.matches;

      let focusIdx = 0, minDist = Infinity;

      cards.forEach((card, idx) => {
        const cr = card.getBoundingClientRect();
        const cardCenter = cr.left + cr.width / 2;
        const dist = Math.abs(viewCenter - cardCenter);
        if (dist < minDist) { minDist = dist; focusIdx = idx; }

        const t = clamp(1 - (dist / (viewW * 0.5)), 0, 1);
        let scale = prefersReduced ? 1 : (baseScaleData + (1 - baseScaleData) * t);

        const maxScaleByWidth = viewW / cardWidth;
        const hardMax = isMobile ? Math.min(1, maxScaleByWidth) : maxScaleByWidth;
        scale = Math.min(scale, hardMax);

        card.style.setProperty('--s', scale.toFixed(3));
        card.classList.toggle('is-dimmed', idx !== focusIdx);
      });

      if (focusIdx !== lastFocus) {
        lastFocus = focusIdx;
        if (live) live.textContent = `Step ${focusIdx + 1} of ${cards.length}`;
        cards.forEach((c, i) => c.classList.toggle('is-focus', i === focusIdx));
      }
    }

    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(() => { rafId = null; update(); });
    }

    const ro = new ResizeObserver(layout);
    if (viewport) ro.observe(viewport);

    window.addEventListener('resize', layout, { passive: true });
    window.addEventListener('orientationchange', layout, { passive: true });

    if (mqlMobile.addEventListener) mqlMobile.addEventListener('change', layout);
    else if (mqlMobile.addListener) mqlMobile.addListener(layout);

    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('load', layout);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => layout()).catch(() => {});
    }

    layout();
  });
})();